import { render, staticRenderFns } from "./PrintDeptSelectComponent.vue?vue&type=template&id=423c3b48&scoped=true&"
import script from "./PrintDeptSelectComponent.vue?vue&type=script&lang=js&"
export * from "./PrintDeptSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423c3b48",
  null
  
)

export default component.exports